import { toast } from 'react-toastify';

export const handleFormClick = (href?: string, text?: string) => {
  if (!href) {
    toast.warn(text || 'Элсэлтийн бүртгэл хийх хугацаа дууссан байна.');
    return;
  }
  window.open(href, '_blank');
};
